import { useDispatch, useSelector } from 'react-redux';
import { closeSession, selectSession } from '@client';
import { useClerkClientAuth } from '@client/hooks/useClerkClientAuth';
import { clearRoleOverride } from '@client/hooks/useRoleSwitch';
import { posthogReset } from '@shared/posthog';

export const useClientSignOut = (redirectUrl = '/') => {
  const dispatch = useDispatch();
  const { clerkSignOut } = useClerkClientAuth();

  return () => {
    clearRoleOverride();
    dispatch(closeSession());
    posthogReset();
    clerkSignOut({ redirectUrl });
  };
};

const removeLocalSignOutState = (): void => {
  try {
    localStorage.removeItem('clientsSearchText');

    const prefixes = ['columnVisibility:', 'sorting:', 'waterlily:idle-activity:'];

    Object.keys(localStorage)
      .filter(key => prefixes.some(prefix => key.startsWith(prefix)))
      .forEach(key => localStorage.removeItem(key));
  } catch {
    // Storage cleanup must never prevent the authentication session from being closed.
  }
};

export const useSignOut = (redirectUrl?: string) => {
  const dispatch = useDispatch();
  const session = useSelector(selectSession);
  const { clerkSignOut, clerkEmail } = useClerkClientAuth();
  const email = clerkEmail || session.advisor?.advisorEmail;

  return () => {
    clearRoleOverride();
    removeLocalSignOutState();
    dispatch(closeSession());
    posthogReset();
    return clerkSignOut({
      redirectUrl: redirectUrl ?? `/?email=${encodeURIComponent(email ?? '')}`,
    });
  };
};
